const locale = {
	// #region Fields
	DIALOG_COMMON_ID: 'ID',
	DIALOG_COMMON_TITLE: 'Name',
	DIALOG_COMMON_DESCRIPTION: 'Description',
	DIALOG_COMMON_ORDER: 'Sorting Order',
	DIALOG_COMMON_TITLE_INITIALS: 'Initials',
	DIALOG_COMMON_DISABLED: 'Disabled',
	DIALOG_COMMON_ERP_ID: 'ERP ID'
	// #endregion
};

export default locale;
